import moment from "moment";
import { useCallback, useEffect, useState } from "react";

import { DATE_FORMATS } from "../types";

export const useIsFutureTime = (endDate: string) => {
  const [isFutureTime, setIsFutureTime] = useState<boolean>(false);

  const checkIfIsFutureTime = useCallback((): boolean => {
    const givenTime = moment(endDate, DATE_FORMATS.DateHoursMinutes);
    return moment().isBefore(givenTime);
  }, [endDate]);

  useEffect(() => {
    setIsFutureTime(checkIfIsFutureTime());
  }, [checkIfIsFutureTime]);

  return { isFutureTime };
};
